import React from 'react';
import { View, StyleSheet,Image } from "react-native";
import { Text, Styles } from "./../../components/UI-Components";


const backImage = require('./../../assets/practice-1.png')

const EmptyFullscreen = (props) => {
    const {images, title} = props;
   return(
       <View style={{position: 'relative', flex: 1}}>
       <View style={styles.mainWrapper}>
            <View style={{flex: 1,justifyContent: 'center', alignItems: 'center' }}>
                <Image source={images} style={{width: '100%', height:'50%', alignSelf: 'center', resizeMode: 'contain'}}>
                </Image>
            </View>
          
       </View>
       <View style={styles.overLay}>
            <Text style={{justifyContent:'center', alignSelf:'center', color: Styles.testSeriesHeader, fontSize:17, fontWeight:"600"}}>{title}</Text>
        </View>
         </View>
   )
}
const styles = StyleSheet.create({

    mainWrapper:{
       flex: 1,
       backgroundColor: Styles.white,
        zIndex:-100,
    },
    overLay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255,255,255,0.7)',
        zIndex: 100,
        justifyContent:'center',
        alignItems:'center'
        
    }
})

export default EmptyFullscreen;

